import { MODEL_VERSION, SITE } from '@/app/constants';

export const ZH_GUIDE_URL = 'https://shengshu.feishu.cn/docx/Dtv8dbnUKo5glfxDoLXcEwzSnyd';
export const EN_GUIDE_URL = 'https://shengshu.feishu.cn/docx/MtKHd8OhNokOtaxzxQHcdUDPnKh';

const BASE_URL =
  SITE === 'global'
    ? 'https://image01.cf.vidu.studio/vidu/media-asset'
    : 'https://image01-aliyun.vidu.zone/vidu/media-asset';

export const REQUIRED_KEYS = ['style', 'motionLevel'];

export const CHAR2V_TUTORIALS = [
  {
    type: 'tutorial' as const,
    videoUrl: {
      en: `${BASE_URL}/tutorial-char2v-en-beb120f1.mp4`,
      zh: `${BASE_URL}/tutorial-char2v-zh-37c41ec0.mp4`,
    },
    posterUrl: {
      en: `${BASE_URL}/tutorial-char2v-en-025ab398.webp`,
      zh: `${BASE_URL}/tutorial-char2v-zh-546fa8ed.webp`,
    },
  },
  {
    type: 'example' as const,
    videoUrl: {
      en: `${BASE_URL}/c2v-01-en-ffb16cc6.mp4`,
    },
    posterUrl: {
      en: `${BASE_URL}/poster1-21212be0.webp`,
    },
    exampleIndex: 0,
  },
  {
    type: 'example' as const,
    videoUrl: {
      en: `${BASE_URL}/c2v-02-en-cfb0ebd9.mp4`,
    },
    posterUrl: {
      en: `${BASE_URL}/poster2-5e503b55.webp`,
    },
    exampleIndex: 1,
  },
  {
    type: 'example' as const,
    videoUrl: {
      en: `${BASE_URL}/c2v-03-en-2278a518.mp4`,
    },
    posterUrl: {
      en: `${BASE_URL}/poster3-bdb78d84.webp`,
    },
    exampleIndex: 2,
  },
  {
    type: 'example' as const,
    videoUrl: {
      en: `${BASE_URL}/c2v-04-en-f63a6f2c.mp4`,
      zh: `${BASE_URL}/c2v-04-440bbc5f.mp4`,
    },
    posterUrl: {
      en: `${BASE_URL}/poster4-7077f41f.webp`,
      zh: `${BASE_URL}/poster5-1e604d77.webp`,
    },
    exampleIndex: 3,
  },
];

export const CHAR2V_PRO_TUTORIALS = [
  CHAR2V_TUTORIALS[0],
  {
    type: 'example' as const,
    videoUrl: {
      en: `${BASE_URL}/q2pro-1-192c9ee9.mp4`,
    },
    posterUrl: {
      en: `${BASE_URL}/q2pro-1-bf0c6ca5.webp`,
    },
    exampleIndex: 0,
  },
  {
    type: 'example' as const,
    videoUrl: {
      en: `${BASE_URL}/q2pro-2-788014db.mp4`,
    },
    posterUrl: {
      en: `${BASE_URL}/q2pro-2-67dd77e2.webp`,
    },
    exampleIndex: 1,
  },
  {
    type: 'example' as const,
    videoUrl: {
      en: `${BASE_URL}/q2pro-3-a77f2eef.mp4`,
    },
    posterUrl: {
      en: `${BASE_URL}/q2pro-3-657e0818.webp`,
    },
    exampleIndex: 4,
  },
  {
    type: 'example' as const,
    videoUrl: {
      en: `${BASE_URL}/q2pro-4-3766439f.mp4`,
    },
    posterUrl: {
      en: `${BASE_URL}/q2pro-4-92d8bfbc.webp`,
    },
    exampleIndex: 5,
  },
];

export const IMG2V_TUTORIALS = [
  {
    type: 'tutorial' as const,
    videoUrl: {
      en: `${BASE_URL}/tutorial-i2v-en-02fd61c1.mp4`,
      zh: `${BASE_URL}/tutorial-i2v-zh-f7b80686.mp4`,
    },
    posterUrl: {
      en: `${BASE_URL}/tutorial-i2v-en-a84591ed.webp`,
      zh: `${BASE_URL}/tutorial-i2v-zh-1d23a1e9.webp`,
    },
  },
  {
    type: 'example' as const,
    videoUrl: {
      en: `${BASE_URL}/i2v-01-en-d636fc0d.mp4`,
      zh: `${BASE_URL}/i2v-01-43ec8d94.mp4`,
    },
    posterUrl: {
      en: `${BASE_URL}/i2v-01-1-en-dcb21d0a.webp`,
      zh: `${BASE_URL}/i2v-01-1-v2-da251914.webp`,
    },
    exampleIndex: 0,
  },
  {
    type: 'example' as const,
    videoUrl: {
      en: `${BASE_URL}/i2v-02-4514772f.mp4`,
    },
    posterUrl: {
      en: `${BASE_URL}/i2v-02-1-ebe3cf46.webp`,
      zh: `${BASE_URL}/i2v-02-1-ebe3cf46.webp`,
    },
    thumbnailUrl: {
      en: `${BASE_URL}/i2v-02-2-e9275db3.webp`,
      zh: `${BASE_URL}/i2v-02-2-e9275db3.webp`,
    },
    exampleIndex: 1,
  },
  {
    type: 'example' as const,
    videoUrl: {
      en: `${BASE_URL}/i2v-03-en-f7e22c71.mp4`,
      zh: `${BASE_URL}/i2v-03-0c3f870b.mp4`,
    },
    posterUrl: {
      en: `${BASE_URL}/i2v-04-1-en-03-fe6a358e.webp`,
      zh: `${BASE_URL}/i2v-03-1-2fdc95c9.webp`,
    },
    thumbnailUrl: {
      zh: `${BASE_URL}/i2v-03-2-1de44aa4.webp`,
    },
    exampleIndex: 2,
  },
  {
    type: 'example' as const,
    videoUrl: {
      en: `${BASE_URL}/i2v-03-0c3f870b.mp4`,
      zh: `${BASE_URL}/i2v-04-a6320d49.mp4`,
    },
    posterUrl: {
      en: `${BASE_URL}/i2v-03-1-2fdc95c9.webp`,
      zh: `${BASE_URL}/i2v-04-1-dd62ef4b.webp`,
    },
    thumbnailUrl: {
      en: `${BASE_URL}/i2v-03-2-1de44aa4.webp`,
      zh: `${BASE_URL}/i2v-04-1-dd62ef4b.webp`,
    },
    exampleIndex: 3,
  },
];

export const IMG2V_Q3_TUTORIALS = [
  IMG2V_TUTORIALS[0],
  {
    type: 'example' as const,
    videoUrl: {
      en: `${BASE_URL}/q3-1-ecf49481.mp4`,
      zh: `${BASE_URL}/q3-1-zh-f22c4a05.mp4`,
    },
    posterUrl: {
      en: `${BASE_URL}/1-67bf07f8.webp`,
    },
    exampleIndex: 0,
  },
  {
    type: 'example' as const,
    videoUrl: {
      en: `${BASE_URL}/q3-2-ed4dcdc3.mp4`,
      zh: `${BASE_URL}/q3-2-zh-74525126.mp4`,
    },
    posterUrl: {
      en: `${BASE_URL}/2-a6b92d88.webp`,
    },
    exampleIndex: 1,
  },
  {
    type: 'example' as const,
    videoUrl: {
      en: `${BASE_URL}/q3-3-fa1bb759.mp4`,
      zh: `${BASE_URL}/q3-3-zh-fa1bb759.mp4`,
    },
    posterUrl: {
      en: `${BASE_URL}/3-8d393c9f.webp`,
    },
    exampleIndex: 2,
  },
  {
    type: 'example' as const,
    videoUrl: {
      en: `${BASE_URL}/q3-4-69da09ee.mp4`,
      zh: `${BASE_URL}/q3-4-zh-ba4571f1.mp4`,
    },
    posterUrl: {
      en: `${BASE_URL}/4-d1ed84f5.webp`,
    },
    exampleIndex: 3,
  },
];

export const getChar2VTutorials = (modelVersion?: string) => {
  if (modelVersion === MODEL_VERSION.Q2_PRO) {
    return CHAR2V_PRO_TUTORIALS.map((tutorial) => ({
      ...tutorial,
      caseKey:
        'exampleIndex' in tutorial && tutorial.exampleIndex !== undefined
          ? `legacy-character2video-pro-${tutorial.exampleIndex + 1}`
          : undefined,
    }));
  }
  return CHAR2V_TUTORIALS.map((tutorial) => ({
    ...tutorial,
    caseKey:
      'exampleIndex' in tutorial && tutorial.exampleIndex !== undefined
        ? `legacy-character2video-${tutorial.exampleIndex + 1}`
        : undefined,
  }));
};

export const getImg2VTutorials = (modelVersion?: string) => {
  if (modelVersion === MODEL_VERSION.Q3) {
    return IMG2V_Q3_TUTORIALS.map((tutorial) => ({
      ...tutorial,
      caseKey:
        'exampleIndex' in tutorial && tutorial.exampleIndex !== undefined
          ? `legacy-img2video-q3-${tutorial.exampleIndex + 1}`
          : undefined,
    }));
  }
  return IMG2V_TUTORIALS.map((tutorial) => ({
    ...tutorial,
    caseKey:
      'exampleIndex' in tutorial && tutorial.exampleIndex !== undefined
        ? `legacy-img2video-${tutorial.exampleIndex + 1}`
        : undefined,
  }));
};

export const BACKFILL_TIME_DELAY = 1000;
